import {
  Divider,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Stack,
  useDisclosure,
} from '@chakra-ui/react';
import { MdLogout, MdSettings } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { HelivanAvatar } from '../helivan/HelivanAvatar';
import { HelivanButton } from '../helivan/HelivanButton';
import { HelivanColor } from '../helivan/HelivanColor';
import { HelivanText } from '../helivan/HelivanText';

export const ProfileDropdown = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { backendUser, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed', error);
    }
  };

  // Signed-out visitors get prominent Sign in / Sign up CTAs instead of a menu.
  if (!isAuthenticated) {
    return (
      <HStack spacing={2}>
        <HelivanButton
          variant="outline"
          size="sm"
          onClick={() => navigate('/login')}
        >
          <HelivanText variant="smallBody" colorOverride={HelivanColor.text.blueDark}>
            Sign in
          </HelivanText>
        </HelivanButton>
        <HelivanButton
          variant="green"
          size="sm"
          onClick={() => navigate('/login')}
        >
          <HelivanText variant="smallBody" colorOverride="white">
            Sign up
          </HelivanText>
        </HelivanButton>
      </HStack>
    );
  }

  return (
    <Popover isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <button onClick={onOpen}>
          <HelivanAvatar clickable={true} />
        </button>
      </PopoverTrigger>
      <PopoverContent minWidth="220px" maxWidth="280px">
        <PopoverArrow />
        <PopoverBody p={3}>
          <Stack spacing={3}>
            {/* User Info */}
            <HStack spacing={3} p={1}>
              <HelivanAvatar />
              <Stack spacing={0} flex="1" minW={0}>
                <HelivanText
                  variant="smallBody"
                  colorOverride={HelivanColor.text.black}
                  style={{ fontWeight: 600 }}
                >
                  {backendUser?.fullName ?? ''}
                </HelivanText>
                <HelivanText
                  variant="smallBody"
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {backendUser?.email}
                </HelivanText>
              </Stack>
            </HStack>

            <Divider borderColor={HelivanColor.border.primary} />

            {/* Settings */}
            <HStack
              _hover={{ cursor: 'pointer', bg: HelivanColor.hover.primary }}
              onClick={() => {
                onClose();
                navigate('/settings');
              }}
              p={2}
              spacing={2}
              borderRadius="6px"
            >
              <MdSettings color={HelivanColor.text.blueMid} size={16} />
              <HelivanText
                variant="smallBody"
                colorOverride={HelivanColor.text.blueDark}
              >
                Settings
              </HelivanText>
            </HStack>

            {/* Log out */}
            <HStack
              _hover={{ cursor: 'pointer', bg: HelivanColor.hover.primary }}
              onClick={handleLogout}
              p={2}
              spacing={2}
              borderRadius="6px"
            >
              <MdLogout color={HelivanColor.text.blueMid} size={16} />
              <HelivanText
                variant="smallBody"
                colorOverride={HelivanColor.text.blueDark}
              >
                Log out
              </HelivanText>
            </HStack>
          </Stack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
